module.exports = __webpack_public_path__ + "static/media/articles-bg.3b1a5ee8.jpg";